import React, { type ReactNode, type SyntheticEvent } from 'react';

export const Wrapper = (props: {
	onSubmit: (e: SyntheticEvent) => void;
	children: ReactNode;
}): React.JSX.Element => (
	<div
		data-testid="forge-ui-async.common.ui.submit-stop-propogation-wrapper.forge-stop-propagation-wrapper"
		onSubmit={props.onSubmit}
	>
		{props.children}
	</div>
);

export const StopSubmitPropagation = ({ children }: { children: ReactNode }): React.JSX.Element => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleSubmit = (e: any) => {
		e.stopPropagation();
	};

	return <Wrapper onSubmit={handleSubmit}>{children}</Wrapper>;
};
